export default __webpack_public_path__ + "static/bariol_serif_regular_italic-webfont-0975e63f4f3f2190ee4111edc9b34580.woff2";